module.exports = __webpack_public_path__ + "img/media_comms_screenshot.b37cab77.png";